import React from 'react'
import { Container } from '@/components/shared/Container'
import styled from 'styled-components'

const StyledVideo = styled.div`
  position: relative;
  padding-bottom: 56.25%;
  margin-top: 50px;
  margin-bottom: 56px;
  height: 0;
  overflow: hidden;
  iframe,
  object,
  embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`

type VideoRecord = {
  id?: string
  videoUrl?: { providerUid?: string }
}

export const VideoBlock = ({ record }: { record: VideoRecord }) => {
  return (
    <Container $size="narrow" className="video-iframe-container">
      <StyledVideo className="video-iframe">
        <iframe
          width="100%"
          src={`https://www.youtube.com/embed/${record?.videoUrl?.providerUid}?${Date.now()}&controls=0`}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          loading="lazy"
        ></iframe>
      </StyledVideo>
    </Container>
  )
}
